import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
const TemplateLayoutHeader = ({ children }) => {
    const [element, setElement] = useState();
    useEffect(() => {
        const el = document.getElementById('template-layout-header');
        if (el) {
            setElement(el);
        }
    }, []);
    return ReactDOM.createPortal(children, element || document.createElement('div'));
};
export default TemplateLayoutHeader;
